import {
  Box,
  createStyles,
  Text,
  Modal,
  Table,
  Paper,
  ScrollArea,
  Center,
} from "@mantine/core";
import swal from "sweetalert";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import TableLoader from "../TableLoader";
import RecordNotFound from "../RecordNotFound";
import CustomBillingPagination from "../Pagination/CustomBillingPagination";
import BillingSearchAll from "../Document/BilllingSearchAll";
import { getBillingProvider } from "../../services/billingprovider";
// import { getdiagnosiscode } from "../../services/servicecode";

const useStyles = createStyles(() => ({
  mainbox: {
    background: "#FFF",
    padding: "12px 8px",
  },
  addbox: {
    padding: "15px 13px 54px 13px",
    borderRadius: "16px",
    border: "1px solid #E5E5EA",
    background: "#FCFCFC",
  },

  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },

  tableRoot: {
    "tbody tr:hover td": {
      backgroundColor: "#FFF6ED !important",
    },
  },

  selected: {
    "& td": {
      background: "#FFF6ED",
    },
  },

  width50: {
    width: "50%",
  },

  mainbtn: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
    marginTop: "46px",
    marginBottom: "78px",
  },

  formRow: {
    width: "100%",
    display: "flex",
    gap: "17px",
    marginBottom: "20px",
    marginTop: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },

    flexend: {
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  selectnumber: {
    width: "140px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    width: "min-content",
    // justifyContent:'flex-end'
  },

  searchbox: {
    // marginTop: "50px",
    // marginBottom: "50px",
    background: "#FFF",
    width: "60%",
    margin: "auto",
    paddingBottom: "12px",
    paddingTop: "20px",
  },

  row: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "400",
    color: "#000",

    // "&:hover": {
    //   background: "#FFD580",
    //   opacity: 0.8,
    // },
  },
}));
const bgColor = "#FFFFFF";

function EligibilityProvider({ state, setState,eligibilitystatus,setEligibilitystatus }) {
  const { classes } = useStyles();


  const [scrolled, setScrolled] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [providerSearch, setProviderSearch] = useState("");

  const { loading, allbillingprovider } = useSelector(
    (state) => state.billingprovider
  );

  const SearchBillingProvider = async (providerSearch) => {
    let paylaod = {
      name: providerSearch,
      page: 1,
    };

    console.log("API Call: Search for ", providerSearch);

    try {
      await getBillingProvider(paylaod);
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  // const allpayer = useSelector((state) => state.payer?.allpayer?.payer);

  console.log('eligibilitystatus',eligibilitystatus);
  

  const handleClose = () => {
    setState(false);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    let payload = {
      page: currentPage,
    };
    getBillingProvider(payload);
  }, [currentPage]);





  return (
    <Modal
      // className={classes.addMedicationModal}
      opened={state}
      size={900}
      title="Saved Providers"
      shadow="md"
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius={"md"}
      zIndex={1000}
      styles={{
        title: {
          color: "#000",
          fontSize: "24px",
          fontWeight: "700",
        },
      }}
      sx={{
        ".mantine-1fholi4": {
          color: "#000",
        },
        ".mantine-1ddebd9": {
          background: "#F5F5F5",
        },
        ".mantine-1fholi4:hover": {
          color: "#FFAF4A",
        },
        ".mantine-1q36a81": {
          padding: "0",
        },
      }}
      centered
    >
      <Box className={classes.mainbox}>
        <Box className={classes.searchbox}>
          <BillingSearchAll
            placeholder="Search provider"
            onChange={SearchBillingProvider}
            value={providerSearch}
            setValue={setProviderSearch}
          />
        </Box>
        {loading ? (
          <TableLoader />
        ) : (
          <ScrollArea
            onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
            sx={{ minHeight: "300px" }}
          >
            <Paper
              sx={{
                borderRadius: "8px !important",
                border: "1px solid #E5E5E5 !important",
              }}
              withBorder
            >
              <Table
                highlightOnHover
                className={classes.tableRoot}
                enableStickyHeader={true}
                sx={{
                  fontFamily: "Inter",
                  "tbody tr:hover": {
                    backgroundColor: "#FFF6ED !important",
                  },
                  // borderRadius: "5px",
                  // border: "1px solid #E5E5E5",
                }}
                fontSize={"sm"}
                verticalSpacing={"md"}
              >
                <thead>
                  <tr>
                    <th>
                      <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                        {" "}
                        Provider Name{" "}
                      </Text>
                    </th>
                    <th className={classes.header}>
                      <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                        Provider Type{" "}
                      </Text>{" "}
                    </th>
                    <th className={classes.header}>
                      <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                        Billing Identifier{" "}
                      </Text>
                    </th>
                    <th className={classes.header}>
                      <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                        Text Identifier{" "}
                      </Text>
                    </th>

                    <th className={classes.header}>
                      <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                        Phone Number{" "}
                      </Text>
                    </th>

                    <th className={classes.header}>
                      <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                        Zip Code
                      </Text>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {allbillingprovider?.billingprovider?.length > 0 ? (
                    allbillingprovider?.billingprovider?.map((item, index) => {
                        const handleRowClick = async(item) => {
                            setEligibilitystatus((prev) => ({
                              ...prev,
                              provider:item,
                            }));
                          await  handleClose()
                          };
            
                      const bg = index % 2 === 0;
                      const providerselected = eligibilitystatus?.provider?.id === item?.id;


                      return (
                        <tr
                          key={item?.id}
                        //  className={bg ? classes.bg2 : classes.bg1}
                          className={
                            providerselected
                              ? classes.selected
                              : bg
                              ? classes.bg2
                              : classes.bg1
                          }
                          // style={{
                          //   backgroundColor: selectedProviders.some(provider => provider.id === item?.id)
                          //     ? "#FFF6ED !important"
                          //     : isHovered
                          //     ? "#FFD580"
                          //     : "transparent",
                          // }}
                          onClick={() => handleRowClick(item)}
                        >
                          <td className={classes.row}>{item?.name}</td>
                          <td className={classes.row}>
                            {item?.providertype || "-"}
                          </td>
                          <td>
                            <Text
                              ff={"Inter"}
                              fz={"12px"}
                              fw={"400"}
                              color={"#737373"}
                            >
                              {item?.billingIdentifier?.type}
                            </Text>

                            <Text
                              ff={"Inter"}
                              fz={"14px"}
                              fw={"600"}
                              color={"#262626"}
                            >
                              {item?.billingIdentifier?.number}
                            </Text>
                          </td>

                          <td className={classes.row}>
                            {/* {item?.federalTaxID?.number || "-"} */}

                            <Text
                              ff={"Inter"}
                              fz={"12px"}
                              fw={"400"}
                              color={"#737373"}
                            >
                              {item?.federalTaxID?.type}
                            </Text>

                            <Text
                              ff={"Inter"}
                              fz={"14px"}
                              fw={"600"}
                              color={"#262626"}
                            >
                              {item?.federalTaxID?.number}
                            </Text>
                          </td>
                          <td className={classes.row}>{item?.phone || "-"}</td>

                          <td className={classes.row}>
                            {item?.zipcode || "-"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={1000}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                            height: "55vh",
                            gap: "8rem",
                          }}
                        >
                          <RecordNotFound />
                          <Center>
                            <p className={classes.notFoundText}>
                              You don&apos;t have any record, Add Provider
                            </p>
                          </Center>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Paper>
            <Center>
              <CustomBillingPagination
                data={allbillingprovider?.count}
                itemsPerPage={10}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
              />
            </Center>
          </ScrollArea>
        )}
        ;
      </Box>
    </Modal>
  );
}

export default EligibilityProvider;
